<template><div><h1>VUX V2.4.0 发布日志</h1>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[enhance] 统一弹窗头部样式，和 popup-picker 一致</li>
</ul>
<h2><a href="/zh-CN/components/drawer.html">Drawer</a></h2>
<ul><li>[feature] 新组件：侧边栏(beta)</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[enhance] 当 render-month 变化时重新渲染日历</li>
</ul>
<h2><a href="/zh-CN/components/previewer.html">Previewer</a></h2>
<ul><li>[enhance] 使用图片作为缩略图，防止先显示黑色区域</li>
<li>[enhance] 不再强制要求设置宽高 #1426</li>
</ul>
<h2><a href="/zh-CN/components/radio.html">Radio</a></h2>
<ul><li>[feature] 添加属性 prop:selected-label-style 来支持定义选中项的文字样式</li>
</ul>
<h2><a href="/zh-CN/components/range.html">Range</a></h2>
<ul><li>[fix] 修复一些情况下无法拖到最大值的问题 #1556</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.4.0 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.4.0-237.vue?2d7d20ef